import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';

export const unassignTraining = (trainingId: string, trainingType: 'TaskList' | 'Workflow', userId: string) => {
  const id = uuid.generate();
  const assignables = [
    {
      [trainingType === 'TaskList' ? 'taskListInstanceId' : 'workflowInstanceId']: { id: trainingId },
      _type: trainingType,
    },
  ];
  return submitCommand(
    id,
    { id: id, assignables: assignables, initiatingUserId: userId },
    'UnassignTraining',
    'TrainingUnassigned',
    'TrainingUnassignedError'
  );
};
